<template>
  <div class="cooper-meta">
    <div class="meta-icon-avatar">
      <SvgIcon slot="icon" icon-class="coc-metting" />
    </div>
    <div class="meta-body text-black">
      <div class="line-clamp-text" style="margin-bottom:4px">
        {{meta.operator}}<span class="text-grey" style="padding: 0 4px">{{actStatusText}}</span
        >{{meta.theme}} {{timeRange.beginTime}}-{{timeRange.endTime}}
      </div>
    </div>
  </div>
</template>
<script>
import coopeMixins from './mixins/coope'
// 协作邀请的meta
export default {
  name: 'CoopeMetaBl',
  mixins: [coopeMixins]
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
@import url(./meta.less);
.cooper-meta {
  .meta(2);
  .meta-avatar {
    background-color: #578fff;
  }
  .meta-body {
    line-height: 26px;
  }
}
</style>
